var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18539_54793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6042 19.6027H12.0015V12H19.6042V19.6027Z",
    fill: "#F1511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0007 19.6027H20.396V12H27.9987V19.6027H28.0007Z",
    fill: "#80CC28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6042 28.0012H12.0015V20.3984H19.6042V28.0012Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0007 28.0012H20.396V20.3984H27.9987V28.0012H28.0007Z",
    fill: "#FBBC09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18539_54793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9974,
    height: 16,
    fill: "white",
    transform: "translate(12.0015 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton2);
export default __webpack_public_path__ + "static/media/_Button (2).2507acb2b8f8505200c8ed3685c5954d.svg";
export { ForwardRef as ReactComponent };